<template>
  <div
    v-if="selected_report"
    class="position-relative"
    :style="`font-family: ${selected_report.font_family}`"
  >

    <arrow-button />
    <template v-if="theme_option && theme_option.theme_info?.layout_code === 'full_view'">
      <viewer-header-basic
        :theme_option="theme_option.theme_info"
        :dark_logo_url="dark_logo_url"
        :main_bg_color_gradient="main_bg_color_gradient"
        :content_list_open="content_list_open"
        :show_nav="show_nav"
        :web_view="true"
        :show_sasb_table="show_sasb_table"
        :show_gri_table="show_gri_table"
        :show_tcfd_table="show_tcfd_table"
        :show_dc_table="show_dc_table"
        :active_dc_table="active_dc_table"
        :active_gri_table="active_gri_table"
        :active_sasb_table="active_sasb_table"
        :active_tcfd_table="active_tcfd_table"
        @showTableView="showTableView"
      />
    </template>

    <div v-if="theme_option && theme_option.theme_info?.layout_code === 'sk_chemical'">
      <div
        v-if="selected_report"
        class="position-relative"
        :style="`font-family: ${selected_report.font_family}`"
      >
        <div class="position-relative">
          <viewer-header-basic-sk-chemical
            :web_view="true"
            :show_printing_btn="theme_option ? theme_option.theme_info?.show_printing_btn : true"
            :show_translation_btn="theme_option ? theme_option.theme_info?.show_translation_btn : true"
            :show_sasb_table="show_sasb_table"
            :show_gri_table="show_gri_table"
            :show_tcfd_table="show_tcfd_table"
            :show_dc_table="show_dc_table"
            :active_dc_table="active_dc_table"
            :active_gri_table="active_gri_table"
            :active_sasb_table="active_sasb_table"
            :active_tcfd_table="active_tcfd_table"
            @showTableView="showTableView"
          />

          <div v-if="show_gri_table" :class="`bgray-200 min-vh-100`">
            <b-container class="py-5">
              <b-card class="p-4 my-auto">
                <contents-list-basic-sk-chemical
                  :web_view="true"
                  :show_gri_table="show_gri_table"
                  @showTableView="showTableView"
                >
                </contents-list-basic-sk-chemical>
              </b-card>
            </b-container>
          </div>
        </div>
      </div>
    </div>

    <div v-if="theme_option && theme_option.theme_info?.layout_code === 'no_image_background'">
      <ViewerHeaderNoImageTheme
        :theme_option="theme_option.theme_info"
        :dark_logo_url="dark_logo_url === null ? false : dark_logo_url"
        :content_list_open="content_list_open"
        :main_bg_color_gradient="main_bg_color_gradient"
        :show_sasb_table="show_sasb_table"
        :show_gri_table="show_gri_table"
        :show_tcfd_table="show_tcfd_table"
        :show_dc_table="show_dc_table"
        :active_dc_table="active_dc_table"
        :active_gri_table="active_gri_table"
        :active_sasb_table="active_sasb_table"
        :active_tcfd_table="active_tcfd_table"
        @showTableView="showTableView"
      />

    </div>

    <div v-else-if="theme_option && theme_option.theme_info?.layout_code === 'bh_test'">
      <ViewerHeaderCover
        :theme_option="theme_option.theme_info"
        :dark_logo_url="dark_logo_url === null ? false : dark_logo_url"
        :content_list_open="content_list_open"
        :main_bg_color_gradient="main_bg_color_gradient"
        :show_sasb_table="show_sasb_table"
        :show_gri_table="!show_gri_table"
        :show_tcfd_table="show_tcfd_table"
        :show_dc_table="show_dc_table"
        :active_dc_table="active_dc_table"
        :active_gri_table="active_gri_table"
        :active_sasb_table="active_sasb_table"
        :active_tcfd_table="active_tcfd_table"
        @showTableView="showTableView"
      />
    </div>

    <div id="standard-index-view">
      <div class="bg-white vh-adjust container" v-view="viewHandlerNav" >
        <WaterMark v-if="selected_report.sample_report" />

        <!-- 테스트 -->
        <tcfd-table
          v-if="show_tcfd_table"
          :modal_table="false"
          :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
          :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
          :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
          :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
          :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
          :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
          :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
          :table_header_font_color="
            theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
          "
        >
        </tcfd-table>

        <SASBTableMicro
          v-if="show_sasb_table && theme_option && theme_option.theme_info?.layout_code === 'bh_test'"
          :modal_table="false"
          :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
          :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
          :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
          :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
          :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
          :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
          :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
          :table_header_font_color="
            theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
          "
        >
        </SASBTableMicro>

        <sasb-table
          v-else-if="show_sasb_table"
          :modal_table="false"
          :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
          :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
          :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
          :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
          :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
          :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
          :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
          :table_header_font_color="
            theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
          "
        >
        </sasb-table>

        <g-r-i-table2021-micro
          v-if="show_gri_table && theme_option && theme_option.theme_info?.layout_code === 'bh_test'"
          :modal_table="false"
          :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
          :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
          :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
          :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
          :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
          :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
          :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
          :table_header_font_color="
            theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
          "
        >
        </g-r-i-table2021-micro>

        <gri-table
          v-else-if="show_gri_table"
          :modal_table="false"
          :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
          :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
          :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
          :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
          :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
          :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
          :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
          :table_header_font_color="
            theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
          "
        >
        </gri-table>
      </div>

      <div class="dc-container">
        <data-center-table-micro
          v-if="show_dc_table && theme_option && theme_option.theme_info?.layout_code === 'bh_test'"
          v-view="dcViewHandlerNav"
          :modal_table="false"
          :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
          :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
          :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
          :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
          :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
          :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
          :table_header_font_color="
            theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
          "
        >
        </data-center-table-micro>

        <data-center-table
          v-else-if="show_dc_table"
          v-view="dcViewHandlerNav"
          :modal_table="false"
          :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
          :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
          :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
          :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
          :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
          :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
          :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
          :table_header_font_color="
            theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
          "
        >
        </data-center-table>
      </div>

      <div v-if="$route.hash" class="ml-5 container">
        <b-button variant="light" @click="goFullPage">
          <b-icon-menu-button-fill />
          {{ lang !== 'ENG' ? '전체보기' : 'Show All' }}
        </b-button>
      </div>

      <hr class="border-0 m-0 py-5 container" />

      <div class="py-5 gray-550 f-90 d-flex justify-content-between container">
        <div class="tail-line" style="width: calc(100% - 200px)">
          {{ lang != 'ENG' ? selected_report.report_name : selected_report.report_name_e }}
        </div>
        
        <div
          v-if="theme_option && !theme_option.theme_info?.is_dark_option && selected_report.logo_path !== null"
        >
          <b-img
            :src="$store.state.static_host + selected_report.logo_path"
            class="report-logo-small"
            :style="{ 'max-height': '40px' }"
          ></b-img>
        </div>
        <div v-if="theme_option && theme_option.theme_info?.is_dark_option && dark_logo_url !== null">
          <b-img
            :src="dark_logo_url"
            class="report-logo-small"
            :style="{ 'max-height': '40px' }"
          ></b-img>
        </div>
      </div>
    </div>

    <!-- 인쇄영역 -->
    <div class="d-none d-print-block position-absolute w-100">
      <div id="full-report-preview">
        <b-container class="px-3 vh-100">
          <b-row no-gutters class="h-100">
            <b-col cols="6" class="pl-3">
              <h1 class="f-300 mb-5 line-height-lg" style="padding-top: 10vh">
                {{ lang != 'ENG' ? selected_report.report_name : selected_report.report_name_e }}
              </h1>
              <h6 class="">{{ selected_report.start_date }} ~ {{ selected_report.end_date }}</h6>
            </b-col>

            <b-col class="d-flex justify-content-end align-items-end pr-5">
              <div
                v-if="
                  theme_option && !theme_option.theme_info?.is_dark_option && selected_report.logo_path != null
                "
                style="padding-bottom: 7vh"
              >
                <b-img
                  :src="$store.state.static_host + selected_report.logo_path"
                  class="report-logo-regular"
                ></b-img>
              </div>
              <div
                v-if="theme_option && theme_option.theme_info?.is_dark_option && dark_logo_url !== null"
                style="padding-bottom: 7vh"
              >
                <b-img :src="dark_logo_url" class="report-logo-regular"></b-img>
              </div>
            </b-col>
          </b-row>
        </b-container>

        <div class="bgray-200">
          <b-container class="">
            <b-card class="p-4">
              <h3 class="mb-5">Contents</h3>
              <contents-list-basic></contents-list-basic>
            </b-card>
          </b-container>
        </div>

        <div>
          <!-- v-if="show_tcfd_table" -->
          <tcfd-table
            v-if="show_tcfd_table"
            :modal_table="false"
            :print_mode="true"
            :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
            :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
            "
          >
          </tcfd-table>

          <!-- v-if="show_sasb_table" -->
          <sasb-table
            v-if="show_sasb_table"
            :modal_table="false"
            :print_mode="true"
            :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
            :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
            "
          >
          </sasb-table>

          <!-- v-if="show_gri_table" -->
          <gri-table
            v-if="show_gri_table"
            :modal_table="false"
            :print_mode="true"
            :business_case_mode="theme_option !== null ? theme_option.theme_info?.business_case_mode : ''"
            :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
            "
          >
          </gri-table>

          <data-center-table
            v-if="show_dc_table"
            :modal_table="false"
            :print_mode="true"
            :table_mode="theme_option !== null ? theme_option.theme_info?.table_mode : ''"
            :material_style_option="theme_option !== null ? theme_option.theme_info?.material_style_option : ''"
            :table_style="theme_option !== null ? theme_option.theme_info?.table_style : ''"
            :show_table_line="theme_option !== null ? theme_option.theme_info?.show_table_line : ''"
            :show_table_outline="theme_option !== null ? theme_option.theme_info?.show_table_outline : ''"
            :table_header_color="theme_option !== null ? theme_option.theme_info?.table_header_color : ''"
            :table_header_font_color="
              theme_option !== null ? theme_option.theme_info?.table_header_font_color : ''
            "
          >
          </data-center-table>
        </div>

        <div class="assurance-statement py-5 bgray-100 px-print">
          <template>
            <h3 id="rpa0" class="pt-3 mb-5">
              Appendix. {{ lang != 'ENG' ? '제3자 검증의견서' : 'Independent Assurance Statement' }}
            </h3>
            <view-assurance-statement :preview_mode="true"></view-assurance-statement>
          </template>
        </div>

        <div class=" gray-550 f-90 d-flex justify-content-between footer px-print">
          <div class="tail-line">
            {{ lang != 'ENG' ? selected_report.report_name : selected_report.report_name_e }}
          </div>
          <div v-if="selected_report.logo_path != null">
            <b-img
              :src="$store.state.static_host + selected_report.logo_path"
              class="report-logo-small"
            ></b-img>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import * as ih from '@/components/util';
  import ContentsListBasic from './viewer_components/ContentsListBasic.vue';
  import ContentsListBasicSkChemical from './viewer_components/ContentsListBasicSkChemical.vue';
  import GriTable from './viewer_components/GRITable2021.vue';
  import SASBTable from './viewer_components/SASBTable.vue';
  import TCFDTable from './viewer_components/TCFDTable.vue';
  import DataCenterTable from './viewer_components/DataCenterTable.vue';
  import DataCenterTableMicro from './viewer_components/DataCenterTableMicro.vue';
  import ViewAssuranceStatement from '@/components/report_preview/appendix_subs/ViewAssuranceStatement';
  import ViewerHeaderBasic from './viewer_components/ViewerHeaderBasic.vue';
  import ViewerHeaderNoImageTheme from './viewer_components/ViewerHeaderNoImageTheme.vue';
  import ViewerHeaderBasicSkChemical from './viewer_components/ViewerHeaderBasicSkChemical.vue';
  import WaterMark from '@/components/report_preview/gri2021_viewer/WaterMark';
  import ViewerHeaderCover from './viewer_components/ViewerHeaderCover.vue';
  import GRITable2021Micro from './viewer_components/GRITable2021Micro.vue';
  import SASBTableMicro from './viewer_components/SASBTableMicro.vue';
  import ArrowButton from '../gri2021_viewer/viewer_components/contents_list_new/ArrowButton.vue';

  export default {
    name: 'StandardIndex',
    components: {
      ContentsListBasic,
      ContentsListBasicSkChemical,
      ViewerHeaderBasic,
      ViewerHeaderBasicSkChemical,
      ViewerHeaderNoImageTheme,
      'gri-table': GriTable,
      'sasb-table': SASBTable,
      'tcfd-table': TCFDTable,
      'data-center-table': DataCenterTable,
      ViewAssuranceStatement,
      WaterMark,
      ViewerHeaderCover,
      GRITable2021Micro,
      DataCenterTableMicro,
      SASBTableMicro,
      ArrowButton,
    },
    data() {
      return {
        low_height: false,
        show_nav: true,
        content_list_open: false,
        // theme_option: null,

        show_gri_table: true,
        show_sasb_table: false,
        show_tcfd_table: false,

        show_dc_table: false,
        active_dc_table: false,

        active_gri_table: false,
        active_sasb_table: false,
        active_tcfd_table: false,
        type: null,

        original_url: window.location.href.split('&t')[0],
      };
    },
    props: {
      show_table_list: { type: Boolean, default: false },
      show_business_case_list: { type: Boolean, default: false },
      reload: { type: Boolean, default: false },
    },
    watch: {
      selected_report: {
        handler(newV) {
          if (newV !== undefined) {
            this.check_report_type();
            // document.querySelector('title').textContent = newV.report_name;
          }
        },
      },
      current_report_code: {
        handler(newV) {
          if (newV) {
            // this.get_theme_info({ report_code: newV });
            
          }
        }
      }
    },
  computed: {
      ...mapGetters(['is_viewer']),
      ...mapState(['backend_host', 'static_host']),
      ...mapState('report_list', ['lang', 'view_mode']),
      ...mapState('report_contents', ['theme_option']),

      ...mapGetters('report_list', ['selected_report', 'current_report_code']),
      ...mapState('gri2021_report_view', ['report_structure', 'report_contents_loaded']),
      ...mapGetters('gri2021_report_view', [
        'report_topic_specific_categories',
        'report_universal_categories',
        'report_topic_types',
      ]),
      ...mapState('assurance', ['assurance_status']),
      main_color() {
        return `color:` + this.selected_report.main_color;
      },
      main_bg_color() {
        return `background-color:` + this.selected_report.main_color + `;important!`;
      },
      main_color_sub() {
        return (
          `color:` +
          this.selected_report.main_color +
          `; border-top: 1px solid ` +
          this.selected_report.main_color +
          `!important` +
          `; border-bottom: 1px solid ` +
          this.selected_report.main_color
        );
      },
      cover_img_url() {
        if (this.theme_option?.code && this.theme_option.theme_info.cover_path) {
          return this.static_host + this.theme_option.theme_info.cover_path.replaceAll("\\", "/")
        } else {
          return ""
        }
      },
      dark_logo_url() {
        if (this.theme_option?.code && this.theme_option.theme_info.dark_logo_path) {
          return this.static_host + this.theme_option.theme_info.dark_logo_path.replaceAll("\\", "/")
        } else {
          return ""
        }
      },
      main_bg_color_gradient() {
        if (
          !this.theme_option?.theme_info?.cover_active ||
          this?.cover_img_url === null ||
          this?.cover_img_url === ''
        ) {
          return (
            `background:linear-gradient(0deg, ` +
            this.selected_report.main_color +
            ` -50%, rgba(239,239,239,1) 60%);important!`
          );
        } else {
          const theme_style = {
            'background-image': `url(${this.cover_img_url})`,
            'background-size': 'cover',
            'background-repeat': 'no-repeat',
            opacity: `${this.theme_option.theme_info?.cover_alpha}`,
            color: `${this.theme_option?.theme_info?.title_color}`,
          };

          return theme_style;
        }
      },
    },
  async created() {
      // this.get_theme_info({ report_code: this.selected_report.report_code });
      
      // if (this.is_viewer) {
      //   this.update_view_mode('viewer');
      // } else {
      //   this.update_view_mode('editor');
      // }
    
      // if (process.env.VUE_APP_REPORT_CODE) {
      //   this.update_report_code(process.env.VUE_APP_REPORT_CODE);
      // }
      // if (this.reload == true) {
      //   this.update_report_contents_loaded(false);
      // }

      this.check_report_type();
      await this.initCss();
      this.scrollToHash();
    },
    mounted() {
      window.addEventListener('scroll', this.handleContentList);

      if (this.view_mode !== 'editor') {
        const params = ih.getParamsFromQueryString();
        if (params && params?.lv1 !== undefined) {
          this.update_lv1_key(params.lv1);
          this.update_lv2_key(params.lv2);
        }
      }
    },
    beforeDestroy() {
      this.change_lang('KOR');
      window.removeEventListener('scroll', this.handleContentList);
      for (const customizedCss of document.getElementsByClassName('customized-css-styling')) {
        if (typeof customizedCss.remove === 'function') {
          customizedCss.remove();
        } else if (customizedCss.parentNode) {
          customizedCss.parentNode.removeChild(customizedCss);
        }
      }
    },
    methods: {
      ...mapMutations('report_list', ['update_report_code']),
      ...mapMutations('data_center', ['update_lv1_key', 'update_lv2_key']),
      check_report_type() {
        if (this.selected_report) {
          for (let i of Object.keys(this.selected_report.report_type)) {
            if (i.split('v')[0] === 'GRI') {
              this.active_gri_table = true;
            } else if (i.split('v')[0] === 'SASB') {
              this.fetchSelectedSasb(this.current_report_code);
              this.active_sasb_table = true;
            } else if (i.split('v')[0] === 'TCFD') {
              this.fetchSelectedTcfd(this.current_report_code);
              this.active_tcfd_table = true;
            }
          }

          if (this.selected_report?.data_center) {
            this.active_dc_table = true;
          } else {
          }
        }
      },
      ...mapMutations('gri2021_report_view', ['update_report_contents_loaded']),
      ...mapMutations('report_list', ['update_view_mode', 'change_lang']),
      ...mapActions('report_contents', ['fetchSelectedSasb', 'fetchSelectedTcfd']),
      
      showTableView(type) {
        if (type === 'GRI') {
          this.show_gri_table = true;
          this.show_sasb_table = false;
          this.show_tcfd_table = false;
          this.show_dc_table = false;
        } else if (type === 'SASB') {
          this.show_gri_table = false;
          this.show_sasb_table = true;
          this.show_tcfd_table = false;
          this.show_dc_table = false;
        } else if (type === 'TCFD') {
          this.show_gri_table = false;
          this.show_sasb_table = false;
          this.show_tcfd_table = true;
          this.show_dc_table = false;
        } else if (type === 'Data Center' || type === 'DATA_CENTER') {
          this.show_gri_table = false;
          this.show_sasb_table = false;
          this.show_tcfd_table = false;
          this.show_dc_table = true;
        } else {
          this.show_gri_table = true;
          this.show_sasb_table = false;
          this.show_tcfd_table = false;
          this.show_dc_table = false;
        }

        if (type) {
          ih.updateParamsFromQueryString('t', type.toLowerCase());
        }
      },
      toggleLang() {
        if (this.lang == 'KOR') {
          this.change_lang('ENG');
          document.querySelector('title').textContent = this.selected_report.report_name_e;

          let newUrl = `${window.location.href}&l=KOR`;
          if (window.location.href.includes('&l=')) {
            window.history.pushState({}, '', newUrl);
          }
        } else {
          this.change_lang('KOR');
          document.querySelector('title').textContent = this.selected_report.report_name;

          let newUrl = `${window.location.href}&l=ENG`;
          if (!window.location.href.includes('&l=')) {
            window.history.pushState({}, '', newUrl);
          }
        }
      },
      viewHandlerNav(event) {
        if (event.type !== 'progress' && event.scrollPercent > 0.035) {
          this.show_nav = true;
        } else {
          this.show_nav = false;
        }
      },
      dcViewHandlerNav() {
        if (window.scrollY > 0 && window.innerWidth > 300) {
          this.show_nav = true;
        } else {
          this.show_nav = false;
        }
      },
      handleContentList() {
        if (window.scrollY > 0 && window.innerWidth > 800) {
          this.content_list_open = true;
        } else {
          this.content_list_open = false;
        }
      },
      async initCss() {
        const beforeStyledSheet = document.getElementsByClassName('customized-css-styling');
        if (beforeStyledSheet.length > 0) {
          for (const element of beforeStyledSheet) {
            element.remove();
          }
        }

        const result = await axios.post(
          process.env.VUE_APP_BACKENDHOST + '/custom_theme/add_custom_theme',
          {
            report_code: this.current_report_code,
          }
        );

        const styleElement = document.createElement('style');
        styleElement.classList.add('customized-css-styling');
        styleElement.innerHTML = result?.data?.css_content || '';
        document.head.appendChild(styleElement);

      },

      scrollToHash() {
        this.$nextTick(() => {
          const hash = window.location.hash;
          if (hash) {
            const element = document.querySelector(hash);

            if (element && element !== 'null') {
              element.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
          }
        });
      },

      goFullPage() {
        ih.anchorGo(null);
      },
    },
  };
</script>
<style>
  @media print {
    .footer {
      background-color: #fff;
      color: black;
      text-align: center;
      padding: 0;
      margin-top: auto;
    }
  }

  .dc-container {
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    padding-right: 20px;
    padding-left: 20px;
  }

  @media (max-width: 1200px) {
    .dc-container {
      padding-right: 15px;
      padding-left: 15px;
    }
  }

  @media (max-width: 768px) {
    .dc-container {
      padding-right: 10px;
      padding-left: 10px;
    }
  }

  .assurance-statement {
    page-break-before: always;
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    max-width: 100%;
    page-break-inside: avoid;
  }
</style>
